import Loadable from 'react-loadable';
import Loading from '../../components/Loading';

const withLoading = dynamicImport => Loadable({
    loader: dynamicImport,
    loading: Loading,
});

export default withLoading;
